import { fetcher } from '@commenda/utils';
import { TTPDocumentRecord } from './types';

type ApproveTPDocumentResult =
  | { ok: true; data: TTPDocumentRecord }
  | { ok: false; error: string };

const approveTPDocument = async (
  recordId: string
): Promise<ApproveTPDocumentResult> => {
  const res = await fetcher(`tp-document-record/${recordId}/approve`, {
    method: 'POST',
    body: {},
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to approve document' };
  }

  const data = (await res.json()) as TTPDocumentRecord;
  return { ok: true, data };
};

export { approveTPDocument };
export type { ApproveTPDocumentResult };
